var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS4UsernameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3336 8.33333C19.3336 12.3833 16.0503 15.6667 12.0003 15.6667C7.95023 15.6667 4.66699 12.3833 4.66699 8.33333C4.66699 4.28324 7.95023 1 12.0003 1C16.0503 1 19.3336 4.28324 19.3336 8.33333Z",
    stroke: "#F37A50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9177 19.3335H7.08236C6.19774 19.3335 5.75543 19.3335 5.35978 19.418C3.99046 19.7104 2.80639 20.738 2.14301 22.21C1.95134 22.6351 1.81147 23.1404 1.53173 24.1511C1.19558 25.3653 1.02752 25.9725 1.00479 26.4622C0.924618 28.19 1.85833 29.7499 3.24475 30.2046C3.63771 30.3335 4.16918 30.3335 5.23214 30.3335H18.7679C19.8309 30.3335 20.3624 30.3335 20.7553 30.2046C22.1416 29.7499 23.0753 28.19 22.9952 26.4622C22.9725 25.9725 22.8044 25.3653 22.4683 24.1511C22.1886 23.1404 22.0487 22.6351 21.8569 22.21C21.1936 20.738 20.0095 19.7104 18.6401 19.418C18.2445 19.3335 17.8023 19.3335 16.9177 19.3335Z",
    stroke: "#F37A50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS4UsernameIcon);
export default __webpack_public_path__ + "static/media/s4-username-icon.e43c26195c4c07ab546bff122da218ad.svg";
export { ForwardRef as ReactComponent };